import Swiper, { Pagination } from 'swiper8'

(function ($) {    
    new Swiper('.cards-slider', {
        modules: [Pagination],
        grabCursor: true,
        slidesPerView: 1,
        autoplay: false,
        spaceBetween: 40,
        pagination: {
            el: '.slider-pagination',
            bulletClass: 'slider-pagination__bullet',
            bulletActiveClass: 'slider-pagination__bullet--active',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1055: {
                slidesPerView: 3,
            }
        }
    });
    
})(window.jQuery);
